import React from 'react';
import { useTranslation } from 'react-i18next';
import { EpisodeLinks } from './EpisodeLinks';
import { MetaInformation } from './MetaInformation';
import { ShowSectionDesktop } from './ShowSectionDesktop';
import { VideoActions } from './VideoActions';
import { Description, Layout, Lead, ShowMore, StyledVideoDescription, Title } from './VideoDescription.styles';
import { isLivestream } from '../../../../../play-core/models/Media';
import { shortenText } from '../../../../../play-core/utils/string-helper';
import { useBottomDialogDispatch } from '../../../components/BottomDialog/BottomDialogContext';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { YouthProtectionInfo } from '../../../components/YouthProtection/YouthProtectionInfo';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useMediaTeaserConfig } from '../../../providers/UiConfigProvider/UiConfigContext';
import { formatTitleWithoutSeasonEpisode } from '../../../utils/media-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoDescription = ({
  videoDetail,
  extended = false
}) => {
  const {
    showsSupported
  } = useVideoConfig();
  const dispatch = useBottomDialogDispatch();
  const {
    displaySeasonAndEpisodes
  } = useMediaTeaserConfig();
  const topicList = videoDetail?.topics?.map(topic => topic.id) || [];
  const showSeasonAndEpisode = displaySeasonAndEpisodes?.topics.some(topic => topicList.includes(topic));
  const {
    t
  } = useTranslation();
  const showMetaInformation = !isLivestream(videoDetail);
  const maxLengthDescription = 300;
  const isExtendable = videoDetail.description && videoDetail.description?.length >= maxLengthDescription;
  const title = showSeasonAndEpisode ? formatTitleWithoutSeasonEpisode(videoDetail.title) : videoDetail.title;
  const description = extended || !videoDetail.description ? videoDetail.description : `${shortenText(videoDetail.description, maxLengthDescription)} `;
  return /*#__PURE__*/_jsxs(Layout, {
    extended: extended,
    children: [/*#__PURE__*/_jsxs(StyledVideoDescription, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: title
      }), videoDetail.youthProtectionColor && /*#__PURE__*/_jsx(YouthProtectionInfo, {
        youthProtectionColor: videoDetail.youthProtectionColor
      }), videoDetail.lead && /*#__PURE__*/_jsx(Lead, {
        children: videoDetail.lead
      }), videoDetail.type !== 'SCHEDULED_LIVESTREAM' && description && /*#__PURE__*/_jsxs(Description, {
        children: [description, !extended && isExtendable && /*#__PURE__*/_jsx(ShowMore, {
          onClick: () => dispatch({
            type: 'show-dialog',
            dialog: /*#__PURE__*/_jsx(PlayContainer, {
              children: /*#__PURE__*/_jsx(VideoDescription, {
                extended: true,
                videoDetail: videoDetail
              })
            })
          }),
          children: t('global.moreInfo')
        })]
      }), (extended || !isExtendable) && videoDetail.episodeLinks.length > 0 && /*#__PURE__*/_jsx(EpisodeLinks, {
        links: videoDetail.episodeLinks
      }), /*#__PURE__*/_jsx(MetaInformation, {
        videoDetail: videoDetail
      }), showMetaInformation && /*#__PURE__*/_jsx(VideoActions, {
        videoDetail: videoDetail
      })]
    }), showsSupported && videoDetail.show && /*#__PURE__*/_jsx(ShowSectionDesktop, {
      show: videoDetail.show,
      onClick: extended ? () => dispatch({
        type: 'remove-dialog'
      }) : undefined
    })]
  });
};